module.exports = __webpack_public_path__ + "img/icons.d51d8cd5.svg";